import {
    PatientGlobalSearchModel,
} from 'one-comp-patient-global-search';

import {
    SET,
    REINIT,
    ADD,
    SPIN,
} from './types';

import {
    Actions,
} from './actions';

/**
 * 
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const patientglobalsearch = (
    context: any,
    initial?: PatientGlobalSearchModel,
) => {

    let initialstate = initial || {
        show: false,
        spin: false,
        data: [],
    };
    return (
        state: PatientGlobalSearchModel,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initialstate;

        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    show: payload
                }
                break;
            case SPIN:
                updated = {
                    ...updated,
                    spin: payload
                }
                break;
            case ADD:
                updated = {
                    ...updated,
                    data: payload,
                }
                break;
            case REINIT:
                updated = initialstate;

                break;
        }
        return updated;
    }
};
